module.exports = __webpack_public_path__ + "media/next_number_out_4.63ac71c3.mp3";